import React, {useEffect} from "react";
import {Controller, useForm} from "react-hook-form";
import {
    Box,
    Button,
    FormHelperText,
    Grid,
    TextField,
    Typography
} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import ColorPicker from "./components/ColorPicker";
import {
    ToggleButton,
    ToggleButtonGroup
} from "@material-ui/lab";

const useStylesAll = makeStyles((theme) => ({
    root: {
        margin: 0,
        marginBottom: 20,
        minWidth: "100%",
    },
    last: {
        margin: 0,
    },
    input: {
        width: "100%",
        maxWidth: "380px",
        marginTop: 20,
        marginBottom: 20,
        "& button": {
            fontSize: "13px",
            lineHeight: "15px",
            width: "25%",
        },
    },
}));

export default function FilmCategoryForm({
                                             disabled,
                                             ...props
                                         }) {
    const {
        title,
        buttonLabel,
        categorySelectArray,
        shouldCategoryIncludeMain,
        shouldCategoryUseMain,
        defaultData,
        submitApi
    } = props;
    const classes = useStylesAll();

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        reset
    } = useForm({
        defaultValues: defaultData
    });

    const onSubmit = (data) => {
        submitApi(data, onReset);
    };

    const onReset = () => {
        reset(
            shouldCategoryUseMain ? {...defaultData, categoryId: -1} : defaultData
        );
    }

    useEffect(() => onReset(), [defaultData])

    return (
        <>
            <Box fontWeight={900} fontSize={13} mb={2}
                 width="100%">
                <Typography
                    variant="p">{title}</Typography>
            </Box>
            <form autoComplete="off"
                  onSubmit={handleSubmit(onSubmit)}>
                <fieldset disabled={disabled}
                          className="fieldset">
                    <Box width="100%">
                        <Controller
                            control={control}
                            name="localizations.en.name"
                            defaultValue={defaultData.localizations.en.name}
                            render={({field}) => {
                                return (
                                    <TextField
                                        id="outlined-basic"
                                        className={classes.root}
                                        label="Name (English)"
                                        variant="outlined"
                                        helperText="The name is how it appears on your site."
                                        {...field}
                                        fullWidth
                                        required
                                    />
                                );
                            }}
                        />
                        <Controller
                            control={control}
                            name="localizations.tc.name"
                            defaultValue={defaultData.localizations.tc.name}
                            render={({field}) => {
                                return (
                                    <TextField
                                        id="outlined-basic"
                                        className={classes.root}
                                        label="Name (Traditional Chinese)"
                                        variant="outlined"
                                        helperText="The name is how it appears on your site."
                                        {...field}
                                        fullWidth
                                        required
                                    />
                                );
                            }}
                        />
                        <FormControl fullWidth
                                     variant="outlined">
                            <InputLabel
                                id="category-selection">
                                Film
                                Category
                            </InputLabel>
                            <Controller
                                name="categoryId"
                                control={control}
                                render={({
                                             field,
                                             fieldState: {error}
                                         }) => (
                                    <Select
                                        labelId="category-selection-label"
                                        id="category-selection"
                                        label="Category"
                                        value={-1}
                                        className={classes.select}
                                        {...field}
                                    >
                                        {
                                            shouldCategoryIncludeMain &&
                                            <MenuItem
                                                value={-1}>
                                                <em>Main
                                                    Category</em>
                                            </MenuItem>
                                        }
                                        {
                                            categorySelectArray.map((category, i) => (
                                                <MenuItem
                                                    key={i}
                                                    value={category.id}>
                                                    <em>{category.localizations.en.name}</em>
                                                </MenuItem>
                                            ))
                                        }
                                    </Select>
                                )}
                            />
                            <FormHelperText>Assign a main
                                category to create a
                                sub-category.</FormHelperText>
                        </FormControl>

                        <Box
                            className={classes.subsectionHeader}>
                            <Grid item xs={12}>
                                <Box>
                                    <h4>
                                        <small>Title
                                            background
                                            color</small>
                                    </h4>
                                </Box>
                            </Grid>
                        </Box>
                        <Box>
                            <ColorPicker
                                getValues={getValues}
                                setValue={setValue}
                                defaultValue={defaultData.backgroundColor}
                                disabled={disabled}
                            />
                        </Box>
                        <Controller
                            control={control}
                            name="status"
                            render={({
                                         field: {
                                             value,
                                             onChange,
                                             ...rest
                                         },
                                         fieldState: {error},
                                     }) => (
                                <ToggleButtonGroup
                                    {...rest}
                                    value={value}
                                    onChange={(event, newFormats) => {
                                        if (newFormats !== null) {
                                            onChange(newFormats);
                                        }
                                    }}
                                    exclusive
                                    aria-label="Status"
                                    className={classes.input}
                                >
                                    <ToggleButton
                                        value={true}
                                        aria-label="Active"
                                        style={{width: "50%"}}
                                        disabled={disabled}
                                    >
                                        Active
                                    </ToggleButton>
                                    <ToggleButton
                                        value={false}
                                        aria-label="Inactive"
                                        style={{width: "50%"}}
                                        disabled={disabled}
                                    >
                                        Inactive
                                    </ToggleButton>
                                </ToggleButtonGroup>
                            )}
                        />
                        <Box display="flex"
                             alignItems="flex-end"
                             alignContent="flex-end">
                            {disabled || (
                                <Box>
                                    <Button
                                        className={classes.last}
                                        variant="contained"
                                        color="primary"
                                        size="large"
                                        type="submit"
                                    >
                                        {buttonLabel}
                                    </Button>
                                </Box>
                            )}
                        </Box>
                    </Box>
                </fieldset>
            </form>
        </>
    );
}
